import { useDispatch, useSelector } from "react-redux";
import { LESSONS } from "../store/selectors";
import { useEffect, useState } from "react";
import { GetLessons_getLessons } from "../__generated__/gql-types/GetLessons";
import useDeleteLessons from "../api/useDeleteLessons";
import { notification } from "antd";
import useGetLessonsListBackOffice from "../api/useGetLessonsListBackOffice";

// date format: MM/DD/YYYY
export const useLessons = () => {
  const dispatch = useDispatch();
  const lessonsSelector = useSelector(LESSONS);
  const [loading, setLoading] = useState(false);
  const [lessons, setLessons] = useState<GetLessons_getLessons[]>([]);

  const deleteLessonMutation = useDeleteLessons();
  const { data, loading: lessonsLoading, refetch } = useGetLessonsListBackOffice();

  const fetchInfo = async () => {
    setLoading(true);
    try {
      await refetch();
      setLoading(false);
    } catch (error) {
      setLoading(false);
      notification["error"]({
        message: "Error",
        description:
          "La información no pudo ser cargada, por favor notifica éste error!",
        placement: "top",
        duration: 3,
      });
    }
  };

  const deleteLesson = async (idLesson: string) => {
    setLoading(true);
    try {
      const response = await deleteLessonMutation({
        deleteLessonId: idLesson,
      });
      if (response.data) {
        notification["success"]({
          message: "Eliminación Exitosa",
          description: "La leccion fue eliminada con exito!",
          placement: "top",
          duration: 3,
        });
        let updateLessons = lessons.filter((lesson) => lesson.id !== idLesson);
        setLessons(updateLessons);
        dispatch({ type: "data/setLessons", payload: updateLessons });
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (data?.getLessonsListBackOffice) {
      const filteredLessons = data.getLessonsListBackOffice
        .filter((lesson: GetLessons_getLessons) => lesson?.deleted_at === null)
        .sort((a: GetLessons_getLessons, b: GetLessons_getLessons) => Number(b.id) - Number(a.id));
      setLessons(filteredLessons);
      dispatch({ type: "data/setLessons", payload: filteredLessons });
    }
  }, [data]);

  useEffect(() => {
    fetchInfo();
  }, []);

  return {
    loading,
    lessons,
    deleteLesson,
  };
};
